
/*** Vendors ***/

/*** components ***/

/*** ========== ***/

/**
 *
 * @param {{
 * }} props Props for the component
 *
 */
const OverBox = ({ wrapper, children, className, ...props }) => {
  return (
    <div className="container">
      <div {...wrapper}>
        <div
          className={`relative inset-x-0 z-50 -mt-15 h-auto p-6 px-4 lg:-mt-32 lg:p-10 ${className || ""
            }`}
          {...props}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default OverBox;
